import { Component } from '@angular/core';
import {BaseComponentService} from '../../services/base-component.service';

@Component({
  selector: 'gpa-adm-pagamento',
  templateUrl: './adm-pagamento.component.html',
  providers: [BaseComponentService]
})

export class AdmPagamentoComponent extends BaseComponentService{


}



// WEBPACK FOOTER //
// ./src/app/pagamento/adm-pagamento/adm-pagamento.component.ts